import { UseQueryResult, useQueries } from '@tanstack/react-query'
import { Dimension } from '../types/Dimension'
import { getDimensionOptions } from './getDimensionOptions'

export const useMultipleCompanyDimensions = <TData = Dimension[]>(
  companyIds?: string[],
  select?: (data: Dimension[]) => TData
): UseQueryResult<TData, Error>[] => {
  const validCompanyIds = companyIds?.filter(Boolean) || []
  const queries = validCompanyIds.map(companyId => getDimensionOptions(companyId, select))
  return useQueries({ queries })
}
